<template>
    <div class="panel__box red">
        <!-- {{ props.one }} -->
        <!-- <template v-for="e in props.one.list" :key="e"> -->
        <p class="full-width flex align-center">
            <!-- <span class="img"><img src="@/assets/images/icon/ico_map_edit.png" /></span> -->
            <span v-if="type === 100" class="img"><img src="@/assets/images/icon/ico_map_file.png" /></span>
            <span v-if="type === 200" class="img"><img src="@/assets/images/icon/ico_map_reset.png" /></span>
            <span v-if="type === 300" class="img"><img src="@/assets/images/icon/ico_map_edit.png" /></span>
            <span class="day"> {{ props.date }}&nbsp;&nbsp;</span>
            <span class="text">{{ props.one.contents }} </span>
        </p>
        <!-- </template> -->
    </div>

    <!-- <p class="full-width flex align-center item">
        <span :class="classForType">{{ typeName }} </span>
        <span v-if="props.one.passageArea" class="subject" style="display: inline-block; width: 4vw">{{ props.one.passageArea }} </span>
        <span class="level" style="display: inline-block; width: 12vw">{{ props.one.level }} &nbsp;&nbsp;{{ props.one.lesson }}</span>
        <template v-if="type !== 300 && type !== 700">
            <span class="passage" style="min-width: 10vw">{{ props.one.passageNumber }} &nbsp;-&nbsp;{{ props.one.passageClass }} </span>
            <span class="passageName"> {{ props.one.passageName }}</span>
        </template>
    </p> -->
</template>

<script setup>
import { onMounted, computed, ref, watch, defineProps } from 'vue';
import Comm from '@/components/common.js';

const props = defineProps({
    // isTop: {
    //     Type: Boolean,
    //     required: true,
    // },
    date: {
        Type: Object,
        required: true,
    },
    one: {
        Type: Object,
        required: true,
    },
});

const type = computed(() => {
    // console.log('--type-sentence-');
    return props?.one?.contents ? Comm.getImgPath(props.one.contents) : '';
});

onMounted(() => {});
</script>

<style scoped lang="scss"></style>
